export const SWITCH_LOADING = 'SWITCH_LOADING'
export const SET_MESSAGE = 'SET_MESSAGE'

export const SET_VIEW = 'SET_VIEW'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const SET_TAB_ACTIVE = 'SET_TAB_ACTIVE'
export const SET_HEIGHT = 'SET_HEIGHT'

export const SET_RENDER = 'SET_RENDER'
export const SET_RENDER_BUTTONS = 'SET_RENDER_BUTTONS'
export const NULLIFY_RENDER = 'NULLIFY_RENDER'
export const SET_RENDER_BUTTONSTATE = 'SET_RENDER_BUTTONSTATE'
export const SET_RENDER_ANSWERSTATE = 'SET_RENDER_ANSWERSTATE'
export const SET_RENDER_LOADEDSTATE = 'SET_RENDER_LOADEDSTATE'

export const APP_INIT = 'APP_INIT'
export const SET_WEEK_ID = 'SET_WEEKID'
export const SET_CURRENT_WEEK = 'SET_CURRENT_WEEK'
export const SET_BUTTONSTATE = 'SET_BUTTONSTATE'
export const SET_ANSWERSTATE = 'SET_ANSWERSTATE'
export const SET_LOADEDSTATE = 'SET_LOADEDSTATE'
export const INIT_BUTTONSTATE = 'INIT_BUTTONSTATE'
export const GET_BUTTONSTATE = 'GET_BUTTONSTATE'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const SET_AUTH_PAGE = 'SET_AUTH_PAGE'
export const SET_ADMIN = 'SET_ADMIN'
export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_STANDINGS = 'SET_STANDINGS'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_LOCAL_ID = 'SET_LOCAL_ID'

export const SET_EDITOR_STATUS = 'SET_EDITOR_STATUS'
export const SET_EDITOR_CURRENT_WEEK = 'SET_EDITOR_CURRENT_WEEK'
export const SET_EDITOR_CURRENT_WEEK_ID = 'SET_EDITOR_CURRENT_WEEK_ID'
export const SET_EDITOR_CURRENT_NAME = 'SET_EDITOR_CURRENT_NAME'
export const SET_EDITOR_CURRENT_QUESTION = 'SET_EDITOR_CURRENT_QUESTION'
export const SET_EDITOR_CURRENT_TOTAL = 'SET_EDITOR_CURRENT_TOTAL'
export const SET_EDITOR_CURRENT_ID = 'SET_EDITOR_CURRENT_ID'
export const SET_EDITOR_CURRENT_DEADLINE = 'SET_EDITOR_CURRENT_DEADLINE'
export const SET_EDITOR_QUESTIONS = 'SET_EDITOR_QUESTIONS'
export const SET_EDITOR_CURRENT_HASH = 'SET_EDITOR_CURRENT_HASH'
export const SET_EDITOR_FROM_WEEKLIST = 'SET_EDITOR_FROM_WEEKLIST'
export const SET_EDITOR_WEEK_ACTIVITY = 'SET_EDITOR_WEEK_ACTIVITY'
export const CLEAR_EDITOR = 'CLEAR_EDITOR'

export const SEE_OTHER_USER = 'SEE_OTHER_USER'
export const SWITCH_YOURSELF = 'SWITCH_YOURSELF'
export const CLEAN_OTHER_USER = 'CLEAN_OTHER_USER'
export const SET_CURRENT_ERROR = 'SET_CURRENT_ERROR'
export const GET_OTHER_NAME = 'GET_OTHER_NAME'
